(() => {
  const key = 'evobeaute-wishlist-v1';
  let saved = [];
  try { const value = JSON.parse(localStorage.getItem(key) || '[]'); if (Array.isArray(value)) saved = value.filter(id => typeof id === 'string'); } catch {}
  const refresh = () => {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(button => {
      const active = saved.includes(button.dataset.wishlistToggle);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? button.dataset.removeLabel : button.dataset.addLabel);
    });
    let visible = 0;
    document.querySelectorAll('[data-wishlist-item]').forEach(item => {
      item.hidden = !saved.includes(item.dataset.wishlistItem);
      if (!item.hidden) visible++;
    });
    document.querySelectorAll('[data-wishlist-empty]').forEach(item => { item.hidden = visible > 0; });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    const id = button.dataset.wishlistToggle;
    saved = saved.includes(id) ? saved.filter(value => value !== id) : [...saved, id];
    try { localStorage.setItem(key, JSON.stringify(saved)); } catch {}
    refresh();
  });
  window.addEventListener('storage', event => {
    if (event.key !== key) return;
    try { const value = JSON.parse(event.newValue || '[]'); saved = Array.isArray(value) ? value.filter(id => typeof id === 'string') : []; } catch { saved = []; }
    refresh();
  });
  document.addEventListener('shopify:section:load', refresh);
  refresh();
})();
